import { css } from "@emotion/react";


export const emotionGlobalCss = css`
.heroImage {
  height: 220px;
  background-size: cover;
  background-position: center;
  display: flex;
  justify-content: flex-start;
  align-items: center
}

.heroImage .wrap {
  width: 100%;
  text-align: center
}
.heroImage.contactMap {
  min-width: 250px;
  height: auto
}

.heroImage.contactMap .innerHeroImage {
  text-align: left;
  max-width: 400px;
  margin: 60px 0;
  padding: 40px 30px;
  background-color: rgba(255, 255, 255, .9)
}

.heroImage.contactMap .innerHeroImage h1 {
  font-weight: 900;
  margin-bottom: 22px
}

.heroImage.contactMap .innerHeroImage p {
  margin-bottom: 5px;
  font-size: 1.8rem;
  font-weight: 600
}

.heroImage.contactMap .innerHeroImage form {
  display: flex;
  margin-bottom: 10px
}

.heroImage.contactMap .innerHeroImage form input[type="text"] {
  flex: 1 1 auto;
  padding: 10px 16px;
  border-color: #70c000
}

.heroImage.contactMap .innerHeroImage form input[type="submit"] {
  flex: 0 0 auto;
  background-color: #70c000;
  padding: 16px;
  line-height: 1
}
.heroImage .wrap {
  width: 100%;
  text-align: center
}
.innerHeroImage h1 {
  margin: 0;
  font-weight: 900
}
.home .site-inner {
  padding-top: 0
}
.author-box::before, .clearfix::before, .entry::before, .entry-content::before, .footer-widgets::before, .nav-primary::before, .nav-secondary::before, .pagination::before, .site-container::before, .site-footer::before, .site-header::before, .site-inner::before, .widget::before, .wrap::before {
  content: " ";
  display: table
}

.author-box::after, .clearfix::after, .entry::after, .entry-content::after, .footer-widgets::after, .nav-primary::after, .nav-secondary::after, .pagination::after, .site-container::after, .site-footer::after, .site-header::after, .site-inner::after, .widget::after, .wrap::after {
  clear: both;
  content: " ";
  display: table
}
.site-inner {
  clear: both;
  padding-top: 0px;
  word-wrap: break-word
}
.content, .content-sidebar-sidebar .content, .content-sidebar-sidebar .content-sidebar-wrap, .genesis-responsive-menu .genesis-nav-menu .sub-menu, .genesis-responsive-menu .genesis-nav-menu .sub-menu a, .sidebar-content-sidebar .content, .sidebar-content-sidebar .content-sidebar-wrap, .sidebar-primary, .sidebar-secondary, .sidebar-sidebar-content .content, .sidebar-sidebar-content .content-sidebar-wrap, .site-header .widget-area, .title-area {
  width: 100%
}
.wrap {
  margin: 0 auto;
  max-width: 1280px
}
.flexContact {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 50px 5% 0;

}
.flexContact>div {
  margin-bottom: 50px
}

.flexContact p {
  color: #7f7d7d
}
.leftContac {
  flex: 0 0 48%
}
.leftContac .socialMedia a {
  background-color: #2e2b34;
  border-radius: 5px
}

.leftContac .socialMedia a:hover {
  background-color: #70c000;
  color: #fff
}
h2.borderGreen::after {
  content: "";
  height: 4px;
  width: 100%;
  background-color: #70c000;
  display: block;
  margin: 10px 0
}
h2.borderGreen {
  font-size: 2.4rem;
  font-weight: 900;
  margin-bottom: 22px
}
.eachF {
  margin-bottom: 15px;
  display: flex;
  align-items: center;
  justify-content: space-between
}
.eachF:last-of-type {
  margin-bottom: 28px
}
.leftF {
  margin-left: 5%;
  margin-right: 10%;
  font-size: 4rem;
  color: #70c000;
  flex: 0 0 auto
}

.rightF {
  line-height: 1.2;
  color: #7f7d7d;
  flex: 0 0 75%
}
.socialMedia a {
  background-color: #70c000;
  color: #fff;
  width: 35px;
  height: 35px;
  line-height: 35px;
  display: inline-block;
  text-align: center;
  border-radius: 50%;
  font-size: 16px;
  margin-right: 10px;
  margin-bottom: 10px
}

.socialMedia a i {
  line-height: 35px;
  font-size: 16px
}

.rightContac {
  flex: 0 0 48%
}

div.wpcf7 {
  margin: 0;
  padding: 0
}

div.wpcf7 .screen-reader-response {
  position: absolute;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  height: 1px;
  width: 1px;
  margin: 0;
  padding: 0;
  border: 0
}

div.wpcf7-response-output {
  margin: 2em .5em 1em;
  padding: .2em 1em;
  border: 2px solid red
}

div.wpcf7-mail-sent-ok {
  border: 2px solid #398f14
}

div.wpcf7-mail-sent-ng, div.wpcf7-aborted {
  border: 2px solid red
}

div.wpcf7-spam-blocked {
  border: 2px solid orange
}

div.wpcf7-validation-errors, div.wpcf7-acceptance-missing {
  border: 2px solid #f7e700
}

.wpcf7-form-control-wrap {
  position: relative
}
.wpcf7-form-control{
  width:290px;
}

span.wpcf7-not-valid-tip {
  color: #f00;
  font-size: 1em;
  font-weight: normal;
  display: block
}

.use-floating-validation-tip span.wpcf7-not-valid-tip {
  position: absolute;
  top: 20%;
  left: 20%;
  z-index: 100;
  border: 1px solid red;
  background: #fff;
  padding: .2em .8em
}

span.wpcf7-list-item {
  display: inline-block;
  margin: 0 0 0 1em
}

span.wpcf7-list-item-label::before, span.wpcf7-list-item-label::after {
  content: " "
}

.wpcf7-display-none {
  display: none
}

div.wpcf7 .ajax-loader {
  visibility: hidden;
  display: inline-block;
  background-image: url(//andmar.ca/wp-content/plugins/contact-form-7/includes/css/../../images/ajax-loader.gif);
  width: 16px;
  height: 16px;
  border: 0;
  padding: 0;
  margin: 0 0 0 4px;
  vertical-align: middle
}

div.wpcf7 .ajax-loader.is-active {
  visibility: visible
}

div.wpcf7 div.ajax-error {
  display: none
}

div.wpcf7 .placeheld {
  color: #888
}

div.wpcf7 .wpcf7-recaptcha iframe {
  margin-bottom: 0
}

div.wpcf7 input[type="file"] {
  cursor: pointer
}

div.wpcf7 input[type="file"]:disabled {
  cursor: default
}
.officialForm input.wpcf7-form-control.wpcf7-submit {
  color: #fff;
  text-decoration: none;
  border: 1px solid #70c000;
  padding: 10px 30px;
  font-size: 1.8rem;
  border-radius: 25px;
  background-color: #70c000;
  text-transform: uppercase;
  display: inline-block;
}
.bottomContac h2 {
  font-size: 2.4rem !important;
  font-weight: 700;
  margin-bottom: 22px;
  margin: 15px
}

.bottomContac {
  flex: 1 1 100%
}
.weeklyHours {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap
}
.boxHours {
  flex: 1 0 auto;
  margin: 10px;
  padding: 10px;
  box-shadow: 0 3px 7px 0 rgba(0, 0, 0, .06)
}
.day {
  color: #70c000;
  font-size: 1.4rem;
  text-transform: uppercase;
  font-weight: 400;
  text-align: center;
}

.hour {
  font-weight: 900;
  text-align: center
}




@media only screen and (max-width:1340px) {
  .wrap {
    max-width: 1140px
  }
}






@media only screen and (max-width:1200px) {

  .wrap {
    max-width: 960px
  }
}





@media only screen and (max-width:1023px) {
  .wrap {
    max-width: 800px
  }

}





@media print {
  .site-inner {
    padding-top: 0;
    position: relative;
    top: -100px
  }
  .content, .content-sidebar {
    width: 100%
  }


}







@media (max-width:860px) {
  .heroImage .thisStaticBackGroundImage{
    top: 130px !important;
  }
 .wrap {
    padding-left: 5%;
    padding-right: 5%
  }
}






@media only screen and (max-width:860px) {
  .leftContac, .rightContac {
    flex: 1 1 100%;
  }
  .flexContact{
    margin: 50px 0 0;
  }
}








  
  `;